import React, { useState, useEffect  }  from 'react'

// function handleChange(e) {
	// console.log(e.target.name);
  // console.log(`selected ${e.target.name}  ${e.target.value}`);
// }
let user='';
// if (localStorage.getItem('user')) {
	// const user = JSON.parse(localStorage.getItem('user')).data.user;
	// console.log(user.first_name);
// } else{
	// window.location.href='/login';
// }





function MyProfile() {
	try {
		const user = JSON.parse(localStorage.getItem('user')).user;
		// console.log(user.first_name);
	} catch(e){
		window.location.href='/login';
	}
	const [inputs, setInputs] = useState({});
	const [interests, setInterests] = useState({});
	// const [credentialError, setCredentialError] = useState('');
    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
		const interest_name = event.target.id; 
		if (interest_name.includes("interest")){
			event.target.classList.toggle("clicked-interest");
			console.log('there');
			const interest_value = event.target.innerText;
			
			if (interest_name in interests){
				console.log(setInterests);
				let {[interest_name]:_, ...new_interests} = interests;
				console.log(interest_name, "here already");
				console.log("deleted", interest_name);
				console.log("it is now", new_interests);
				setInterests(new_interests);
				
			}
			else{
				 // setInterests(values => ({...values, [interest_name]: interest_value}))
				 setInputs(values => ({...values, [interest_name]: interest_value}))
				 // setInputs({...inputs, all_inputs: {...inputs.values, [interest_name]: interest_value}});
			}
		}
		else{
			setInputs(values => ({...values, [name]: value}))
		}
    }

	// handleChangeSelect = (value, e) => {
    //     this.setState({
    //         [e.name]: value
    //     });
    //     console.log(e, {
    //         [e.label]: value
    //     })
    // }
	
	
	// const [interests, setInterests] = useState({});
    // const handleInterests = (event) => {
		// // console.log(event.target.classList);
		// event.target.classList.toggle("clicked-interest");
        // const name = event.target.id; 
        // const value = event.target.innerText;
		
		// if (name in interests){
			// console.log(setInterests);
			// let {[name]:_, ...new_interests} = interests;
			// console.log(name, "here already");
			// console.log("deleted", name);
			// console.log("it is now", new_interests);
			// setInterests(new_interests);
			
		// }
		// else{
			 // setInterests(values => ({...values, [name]: value}))
			 // setInputs({...inputs, all_inputs: {...inputs.values, Interests: interests}});
		// }
		// setInterests(values => ({...values, [name]: value}))
		// setInputs({...inputs, all_inputs: {...inputs.values, Interests: interests}});
		
    // }
	
	// useEffect(() => {
    // const newMovies = interests
    // console.log(newMovies)
     // setInputs({...inputs, all_inputs: {...inputs.values, Interests: newMovies}})
  // }, [])
	
	const handleSubmit = (event) => {
		console.log(interests)
		
		// setInputs({...inputs, all_inputs: {...inputs.values, Interests: interests}});
        event.preventDefault();
		// console.log(inputs);
		let userr = JSON.parse(localStorage.getItem('user'));
		// localStorage.setItem('details', JSON.stringify(inputs));
		
		userr.data.user.user_profile =inputs;
		// console.log(userr.data.user.user_profile);
		localStorage.setItem('user', JSON.stringify(userr))
		let usr = JSON.parse(localStorage.getItem('user')).data.user.user_profile;
		console.log(usr);
		// console.log(newMovies)
    }
  return (
  <>
    <div className='container'>
	<br/>
	<p class='green-text subheader'>My Dashboard</p>
	
	<br/>
	<p class='green-text subheader-3'>{user ? user.first_name : ''} Profile</p>
	<br/>
	<div class='avatar'>
		<span>
			  <div class='avatar-profile'>
			  <img  src='./images/contact.png'/>
			  </div>
			  <p class='gray-text subtext-3'>Add profile picture</p>
		  </span>
		  
		  <span>
				<a class='profile-msg subtext-3' href="/profile">View Profile</a>
		  </span>
     </div>
	 
	 <hr style={{ width: '100%'}}/>
	 <form className='edit-profile' onSubmit={handleSubmit}>
		 <div class='profile-bio'>
			<span class='col-sm-2'  style={{ padding:0 }} >
				  <p class='subheader-3'>Bio</p>
			  </span>
			  
			  <span class='col-sm-10'>
					<textarea name="bio" onChange={handleChange}
			  placeholder="Tell us about yourself... "
			  rows="3" 
			  style={{ width: '100%',height: 50, display:'flex', alignItems:'center', border:0, outline: 0}} 
			/>
			  </span>
		 </div>
		 
		  <hr style={{ width: '100%'}}/>
		 
		 <div class='profile-bio'>
			<span class='col-sm-2'  style={{ padding:0 }} >
				  <p class='subheader-3'>Socials</p>
			  </span>
			  
			  <span class='col-sm-10'>
					<input id='match-chat-ig' name="ig" onChange={handleChange} className="profile-ig" type="text" placeholder="Enter your IG username"/>
					<br/>
				<input id='match-chat-twitter' name="twitter" onChange={handleChange} className="profile-twitter" type="text" placeholder="Enter your Twitter handle"/>
			  </span>
		 </div>
		  
		  <hr style={{ width: '100%'}}/>
		  
		  <div class='profile-bio'>
			<span class='col-sm-2'  style={{ padding:0 }} >
				  <p class='subheader-3'>Info</p>
				  <p class='subtext'>Occupation:</p><br/>
				   <p class='subtext'>Smoking:</p><br/>
					<p class='subtext'>Religion:</p><br/>
					<p class='subtext'>Pets:</p><br/>
					<p class='subtext'>Location:</p><br/>
				  
			  </span>
			  
			  <span class='col-sm-10'>
			  <p class='subheader-3'></p><br/>
			  <select name="occupation" defaultValue="select" className="selects" onChange={handleChange} >
		  <option   value="select">select an occupation</option>
		  <option   value="employed">Employed</option>
		  <option nam="occupation"  value="unemployed">Unemployed</option>
		  <option nam="occupation"  value="selfemployed">Self Employed</option>
		</select>
		
		<br/>
			  <select name="smoking"  defaultValue="select"  className="selects" onChange={handleChange}>
		  <option value="select">select a smoking status</option>
		  <option value="smoker">Smoker</option>
		  <option value="nonsmoker">Non Smoker</option>
		</select>
		
		<br/>
			  <select name="religion" defaultValue="select" className="selects"  onChange={handleChange}>
		  <option value="select">select a religion</option>
		  <option value="islam">Islam</option>
		  <option value="christian">Christianity</option>
		  <option value="traditional">Traditional</option>
		  <option value="atheist">Atheist</option>
		</select>
		
		<br/>
			  <select name="pet" defaultValue="select" className="selects" onChange={handleChange}>
		  <option value="select">select a pet preference</option>
		  <option value="cat">Cat</option>
		  <option value="dogs">Dogs</option>
		  <option value="none">None</option>
		</select>
		
		<br/>
			  <select name="location"  defaultValue="select" className="selects" onChange={handleChange}>
		  <option value="select">select your prefered location</option>
		  <option value="Island">Island</option>
		  <option value="Mainland">Mainland</option>
		  <option value="Trenches">Trenches</option>
		</select>
		
			  </span>
		 </div>
		 
		  <hr style={{ width: '100%'}}/>
		
		<div class=''>
				<p class='subheader-3'>Socials</p>
				<p class='subtext'>select your interests</p><br/>
				<ul class="rounded-list">
							<li onClick={handleChange} class='' id="interest1" role="presentation">Football</li>
							<li onClick={handleChange} class='' id="interest2" role="presentation">Basketball</li>
							<li onClick={handleChange} class='' id="interest3" role="presentation">Cooking</li>
							<li onClick={handleChange} class='' id="interest4" role="presentation">Music</li>
							<li onClick={handleChange} class='' id="interest5" role="presentation">Parties</li>
							<li onClick={handleChange} class='' id="interest6" role="presentation">Reading</li>
							<li onClick={handleChange} class='' id="interest7" role="presentation">Gym</li>
							<li onClick={handleChange} class='' id="interest8" role="presentation">Art</li>
							<li onClick={handleChange} class='' id="interest9" role="presentation">Singing</li>
							<li onClick={handleChange} class='' id="interest10" role="presentation">Photography</li>
							<li onClick={handleChange} class='' id="interest11" role="presentation">Dancing</li>
							<li onClick={handleChange} class='' id="interest12" role="presentation">Movies</li>
				</ul>
			  
		 </div>
		
		<div>
			<input type="submit" style={{ padding: '0'}} className='white-text save-btn' value="Save"/>
		</div>
	</form>
	</div>
  
  <br/><br/><br/><br/></>
  )
}

export default MyProfile